import angular from "angular";
import angularFilters from "angular-filter";
import angularUIB from "angular-ui-bootstrap";
import core from "../core/core.module";
import article from "./article";
import articleView from "./article-view/article-view";
import articleHistory from "./article-history/article-history";

angular
    .module('articlesControl.component', [angularFilters, core, article, angularUIB, articleView, articleHistory])
    .component('articlesControl', {
        controller: ['Article', 'notifier', 'Auth', '$uibModal', controller],
        template: require('./articles-control.component.html'),
    });

function controller(Article, notifier, Auth, $uibModal) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.currentPage = 1;
        $ctrl.search = null;
        $ctrl.getList();
    };

    $ctrl.doFilter = function () {
        $ctrl.currentPage = 1;
        $ctrl.getList();
    };

    $ctrl.clearFilter = function () {
        $ctrl.search = null;
        $ctrl.currentPage = 1;
        $ctrl.getList();
    };

    $ctrl.getList = function () {
        Article
            .getList({
                currentPage: $ctrl.currentPage,
                search: $ctrl.search,
            })
            .then(
                function (response) {
                    $ctrl.articles = response.data.articles;
                    $ctrl.totalCount = response.data.totalCount;
                },
                function (error) {
                    notifier.errorResponseNotify(error);
                }
            );
    };

    $ctrl.deleteArticle = function (article, ind) {
        if (!confirm('Вы действительно хотите удалить запись?')) {
            return;
        }
        Article
            .destroy(article.id)
            .then(
                function () {
                    $ctrl.articles.splice(ind, 1);
                    notifier.successNotify('Запись успешно удален');
                },
                function (error) {
                    notifier.errorResponseNotify(error);
                }
            )
    };

    $ctrl.publish = function (article) {
        if (!confirm('Вы действительно хотите опубликовать запись?')) {
            return;
        }
        Article
            .publish(article.id)
            .then(
                function () {
                    article.published_user = Auth.user;
                    article.published_on = new Date();
                    notifier.successNotify('Запись успешно опубликована');
                },
                function (error) {
                    notifier.errorResponseNotify(error);
                }
            );
    };

    $ctrl.openArticle = function (article) {
        $uibModal
            .open({
                component: 'articleView',
                size: 'lg',
                resolve: {
                    article: function () {
                        return article;
                    }
                }
            });
    };

    $ctrl.openHistory = function (article) {
        $uibModal
            .open({
                component: 'articleHistory',
                size: 'md',
                resolve: {
                    article: function () {
                        return article;
                    }
                }
            });
    };
}

export default 'articlesControl.component';



// WEBPACK FOOTER //
// ./resources/assets/modules/articles-control/articles-control.component.js